module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Menadzeri - " + _vm._s(_vm.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "#2b542c",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.openAddUserModal()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" Dodaj menadžera\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "90%",
      "border-radius": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsers), function(user) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.firstName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.lastName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Obriši",
        "name": "Obriši",
        "value": "Obriši"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCompanyStuff(user)
        }
      }
    })])])
  }), 0)])])])]), _vm._v(" "), _c('add-company-stuff-modal', {
    attrs: {
      "show": _vm.openAddOrder,
      "companyId": _vm.companyId
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Ime")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Prezime")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Korisničo ime")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Obriši")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a4fa493!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Company/Managers.vue
// module id = 479
// module chunks = 1